"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _atoms = require("../../atoms");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var IconInput = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var Icon = props.icon;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "relative w-full"
  }, /*#__PURE__*/_react.default.createElement(Icon, {
    className: "absolute right-4 top-3 cursor-pointer",
    width: "1.5rem",
    height: "1.5rem",
    tabIndex: "-1"
  }), /*#__PURE__*/_react.default.createElement(_atoms.Input, _extends({}, props, {
    ref: ref,
    className: "pr-12"
  })));
});

IconInput.propTypes = {
  icon: _propTypes.default.any.isRequired,
  ref: _propTypes.default.any
};
var _default = IconInput;
exports.default = _default;